import { Product } from './types';

export const homeProducts: Product[] = [
  {
    id: 'home-1',
    numericId: 501,
    name: '智能宠物喂食器 GF1',
    description: '自动宠物喂食设备，支持远程控制',
    price: '¥1,299',
    image: '/images/pet/scene/GF1/宠物喂食器主图.jpg',
    cardImage: '/images/home/GF1.png',
    featured: true,
    tag: '新品'
  },
  {
    id: 'home-2',
    numericId: 2,
    name: '头戴式蓝牙耳机 EH1',
    description: '混合有源降噪，单次充电续航长达70小时',
    price: '¥2,499',
    image: '/images/sound/EH1.png',
    cardImage: '/images/home/EH1.png'
  },
  {
    id: 'home-3',
    numericId: 3,
    name: '电动滑板车 S2',
    description: '全铝合金车身，轻便强度高，具备很好的耐用性',
    price: '¥3,999',
    image: '/images/scooter/S2.png',
    cardImage: '/images/home/S2.png',
    tag: '即将上市'
  },
  {
    id: 'home-4',
    numericId: 4,
    name: '激光投线测距仪 LR1',
    description: '高精度激光测距仪，测量快速准确',
    price: '¥899',
    image: '/images/tools/LR1.png',
    cardImage: '/images/home/LR1.png'
  },
  {
    id: 'home-5',
    numericId: 5,
    name: '便携式蓝牙音箱 SP1',
    description: '4D重鼓环绕音效，TWS互联，超低延迟',
    price: '¥799',
    image: '/images/sound/SP1.png',
    cardImage: '/images/home/SP1.png',
    tag: '折扣'
  },
  {
    id: 'home-6',
    numericId: 6,
    name: '智能宠物梳 PC1',
    description: '高效去除浮毛，减少掉毛问题',
    price: '¥399',
    image: '/images/pet/PC1.png',
    cardImage: '/images/home/PC1.png'
  },
  {
    id: 'home-7',
    numericId: 7,
    name: '多功能车充头 MC1',
    description: '快充黑科技，智能芯片，稳定快充',
    price: '¥299',
    image: '/images/tools/MC1.png',
    cardImage: '/images/home/MC1.png'
  }
]; 